import { configureStore } from '@reduxjs/toolkit'
import reducer from 'redux/rootReducer'
import config from 'const/config'

const store = configureStore({
  reducer,
  devTools: config.NODE_ENV !== 'production'
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
